import { Box, Button, Group, Modal, Stack, Text, Title } from "@mantine/core";
import { StripeCheckoutModal } from "@src/components/plan/stripe-checkout-modal";
import clsx from "clsx";
import { useReferralWelcomeController } from "./use-referral-welcome-controller";

export function ReferralWelcomePopup() {
	const {
		opened,
		checkoutModalOpened,
		isRedeeming,
		proMonthly,
		rewardCode,
		referrerName,
		handleClose,
		handleClaimReward,
		handleCheckoutClose,
	} = useReferralWelcomeController();

	if (!proMonthly || !rewardCode) return null;

	return (
		<Modal
			opened={opened}
			onClose={handleClose}
			centered
			withCloseButton={false}
			zIndex={9999}
			size="md"
			radius="md"
			padding="xl"
		>
			<Stack gap="md" align="center">
				<Box
					className={clsx(
						"w-20 h-20 rounded-full flex items-center justify-center",
						"bg-[linear-gradient(90deg,var(--ui-color-brand-primary)_0%,#e8d20b_100%)]",
					)}
				>
					<Text size="48px" style={{ lineHeight: 1 }}>
						🎉
					</Text>
				</Box>

				<Title order={2} ta="center" fw={700} c="var(--ui-color-text-primary)">
					Welcome to illumi!
				</Title>

				<Text ta="center" size="md" c="var(--ui-color-text-secondary)" px="md">
					You've been invited by <strong>{referrerName}</strong>! As a thank
					you, you get <strong>30 days of Pro access for free</strong>.
				</Text>

				<Text ta="center" size="sm" c="var(--ui-color-text-muted)" px="md">
					Unlock advanced models, more AI usage, advanced collaboration
					features, and more.
				</Text>

				<Group gap="sm" w="100%" mt="md">
					<Button
						onClick={handleClaimReward}
						disabled={isRedeeming}
						variant="filled"
						fullWidth
						className={clsx(
							"hover:opacity-90 text-text-inverse font-semibold border-0 overflow-hidden",
							"bg-[linear-gradient(90deg,var(--ui-color-brand-primary)_0%,#e8d20b_100%)]",
						)}
					>
						{isRedeeming ? "Claiming..." : "Claim Your Bonus"}
					</Button>

					<Button variant="subtle" color="gray" onClick={handleClose} fullWidth>
						Maybe Later
					</Button>
				</Group>

				{checkoutModalOpened && (
					<StripeCheckoutModal
						opened={checkoutModalOpened}
						onClose={handleCheckoutClose}
						priceId={proMonthly}
						discountCode={rewardCode}
						zIndex={10000}
					/>
				)}
			</Stack>
		</Modal>
	);
}
